var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1109_3558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 5.54005V6.00005C10.9991 7.07826 10.65 8.12739 10.0044 8.99097C9.35884 9.85454 8.4514 10.4863 7.41743 10.792C6.38347 11.0977 5.27839 11.061 4.26699 10.6873C3.2556 10.3137 2.39208 9.6231 1.80524 8.71859C1.21839 7.81407 0.939651 6.74409 1.01059 5.66821C1.08154 4.59234 1.49836 3.56822 2.1989 2.74859C2.89943 1.92896 3.84615 1.35775 4.89785 1.12013C5.94955 0.882509 7.04989 0.991223 8.03476 1.43005",
    stroke: "#355137",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2.00006L6 7.00506L4.5 5.50506",
    stroke: "#355137",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_3558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.60b000be39d94b4a18d70fbc40628c30.svg";
export { ForwardRef as ReactComponent };